import "./box-filter-consument";
import "./quantity-product";
import "./action-filter";
import "./add2cart";
import "./open-close-filter";
import "./newsletter-form";
import "./single-product-attributes";
import "./single-product-recipe";
import "./single-product-related";
import "./usp-mobile";
// import "./hero-webshop";
